import { Toaster } from 'components/notification/Toaster';
import { func_validation } from 'functions';
import { useAccountAutomation } from './useAccountAutomation.jsx';
import { useBillingUpload } from './useBillingUpload.jsx';
import { useDeleteAccount } from './useDeleteAccount.jsx';
import { useDeactivateAccount } from './useDeactivateAccount.jsx';
import { useEditAccount } from './useEditAccount.jsx';
import { useGenerateInvoice } from './useGenerateInvoice.jsx';
import { useResetModal } from './useResetModal';

export function useTableActions(props) {

    const accountDeletion = useDeleteAccount(props);
    const accountDeactivation = useDeactivateAccount(props);
    const accountAutomation = useAccountAutomation(props);
    const billingUpload = useBillingUpload(props);
    const accountEdit = useEditAccount(props);
    const {
        isModalResetRequired,
        resetModalState
    } = useResetModal({
        ...props,
    });
    const invoiceGeneration = useGenerateInvoice({
        ...props,
        resetModalState, isModalResetRequired
    });

    function handleCloneAccount(selectedAccounts) {
        const {
            setIsFormVisible, setIsEditingAccount
        } = accountEdit;

        if (func_validation.isArrayNotEmpty(selectedAccounts) &&
            func_validation.isArrayLengthEqual(selectedAccounts, 1)) {

            if (func_validation.isFunction(props.setSelectedBillingSetup)) 
                props.setSelectedBillingSetup(selectedAccounts);

            if (func_validation.isFunction(setIsFormVisible)) 
                setIsFormVisible(true);

            if (func_validation.isFunction(setIsEditingAccount)) 
                setIsEditingAccount(false);

            if (func_validation.isFunction(props.setBillingSetupId)) 
                props.setBillingSetupId("");

            if (func_validation.isFunction(props.setBillingSetupDetailsId))
                props.setBillingSetupDetailsId("");

            if (func_validation.isFunction(props.setBillingSetupDiscountId))
                props.setBillingSetupDiscountId("");
        }
        else if (func_validation.isArrayEmpty(selectedAccounts))
            Toaster({ type: "info", msg: "Please select a row" });
        else Toaster({ type: "info", msg: "Please select only 1 row" });
    }

    return {
        handleCloneAccount,
        ...invoiceGeneration,
        ...accountEdit,
        ...accountDeletion,
        ...accountDeactivation,
        ...accountAutomation,
        ...billingUpload
    }
}